import * as ajax from "../../../actions/ajaxCounterActions";
import * as exception from "../../../actions/exceptionActions";

import financieelApi from "../../../api/financieelApi";

import { getStore } from "../../../store/configureStore";
import * as constants from "../../../constants/DomainConstants";
import showToastr from "../../../util/toastr.js";
import redirector from '../../../util/redirector';

import mergeDeep from "../../../util/mergeDeep";

export default class KostOpbrengstEditPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		this.context.setState({
			kostOpbrengst: null
		});

		const dossierId = this.context.props.params.dossierId;
		const kostOpbrengstId = this.context.props.params.kostOpbrengstId;

		if (kostOpbrengstId) {
			this.getKostOpbrengst(kostOpbrengstId);
			this.context.setState({ dossierId: dossierId, kostOpbrengstId: kostOpbrengstId });
		}
		else {
			this.getEmptyKostOpbrengst(dossierId);
			this.context.setState({ dossierId: dossierId });
		}
	}

	loadLayout() {
		this.context.props.loadLayout();
	}

	loadBeads(beadModels) {
		this.context.props.beadsLoaded(beadModels);
	}

	change(event, data) {
		const fieldName = event.target.name ? event.target.name : data.name;
		const value = event.target.value ? event.target.value : data ? data.value : "";
		let model = this.context.state.model;
		let type = this.context.props.type;

		if (fieldName == 'subtypeId') {
			const selectedOkPost = this.context.props.okPosten.filter(item => item.subtype === value)[0];

			model.typeId = selectedOkPost ? selectedOkPost.type : null;
		}

		if (fieldName === 'opbrengstenOfKostenPostId') {
			const selectedOkPost = this.context.props.okPosten.filter(item => item.value === value)[0];

			model.typeId = selectedOkPost ? selectedOkPost.type : null;
			model.subtypeId = selectedOkPost ? selectedOkPost.subtype : null;
			model.opbrengstenOfKostenPostId = selectedOkPost ? selectedOkPost.value : value;
		}

		if (type == constants.KostOpbrengst.KOST) {
			if (fieldName === 'typeId')
				if (value === constants.KostenOpbrengstenInvesteringMainTypes.FinanciëleKost)
					model.subtypeId = constants.KostenSingleSubTypes.FinancieleKostSubType;
				else if (value === constants.KostenOpbrengstenInvesteringMainTypes.UitzonderlijkeKost)
					model.subtypeId = constants.KostenSingleSubTypes.UitzonderlijkeKostSubType;
				else
					model.subtypeId = null;
		}
		else if (type == constants.KostOpbrengst.OPBRENGST) {
			if (fieldName === 'typeId')
				if (value === constants.KostenOpbrengstenInvesteringMainTypes.FinanciëleOpbrengst)
					model.subtypeId = constants.OpbrengstenSingleSubTypes.FinancieleOpbrengstSubType;
				else if (value === constants.KostenOpbrengstenInvesteringMainTypes.UitzonderlijkeOpbrengst)
					model.subtypeId = constants.OpbrengstenSingleSubTypes.UitzonderlijkeOpbrengstSubType;
				else
					model.subtypeId = null;
		}

		if (fieldName !== 'opbrengstenOfKostenPostId') {
			model[fieldName] = value;
		}

		this.context.setState({ model: model, hasUnsavedChanges: true });
	}

	kopieBedragNaarAndereJaren() {
		let model = mergeDeep({}, this.context.state.model);
		const bedragJaar1 = model.bedragJaar1;
		let property = "bedragJaar";

		[2, 3, 4, 5, 6, 7, 8, 9, 10].map(i => {
			const bedragProperty = property + i;
			model[bedragProperty] = bedragJaar1;
		});

		this.context.setState({ model });
	}

	getKostOpbrengst(kostOpbrengstId) {
		this.dispatch(ajax.started());
		financieelApi.getKostOpbrengst(kostOpbrengstId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(response.data);
				this.loadLayout(response.data.item);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	getEmptyKostOpbrengst(dossierId) {
		this.dispatch(ajax.started());
		financieelApi.getEmptyKostOpbrengst(dossierId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterUpdate(response.data);
				this.loadLayout(response.data.item);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	save() {
		this.dispatch(ajax.started());
		financieelApi.saveKostOpbrengst(this.context.state.model)
			.then((response) => {
				this.dispatch(ajax.ended());
				let result = null;
				if (response.data.concurrencyException) {
					this.setStateAfterUpdate(response.data.item, response.data.validationResults);
					result = constants.HAS_CONCURRENCY_EXCEPTION;
				} else if (response.data.hasValidationErrors) {
					this.setStateAfterUpdate(response.data.item, response.data.validationResults);
					result = constants.HAS_VALIDATION_ERRORS;
				} else if (Object.keys(response.data.validationResults).length !== 0) {
					this.setStateAfterUpdate(response.data.item, response.data.validationResults);
					result = constants.HAS_VALIDATION_ERRORS_SAVED;
				} else {
					this.setStateAfterUpdate(response.data.item, {}, false);
					result = constants.SUCCESS;
				}
				let isSaved = showToastr(result);
				if (isSaved) {
					this.context.setState({ hasUnsavedChanges: false });
					if (result === constants.SUCCESS)
						this.goToOverview();
				}
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	goToOverview() {
		const context = this.context;
		const type = this.context.props.type;
		const state = context.state;
		const hasUnsavedChanges = state.hasUnsavedChanges;

		if (hasUnsavedChanges)
			window.parent.scrollTo(0, 350);
		if (type == constants.KostOpbrengst.KOST)
			redirector.goTo(`/financieel/${state.dossierId}/kosten`);
		else if (type == constants.KostOpbrengst.OPBRENGST)
			redirector.goTo(`/financieel/${state.dossierId}/opbrengsten`);
	}

	isReadyToRender() {
		if (!this.context.state.financieelKosten) {
			return false;
		}

		if (this.context.props.okiTypes.length < 1) {
			return false;
		}

		return true;
	}

	setStateAfterUpdate(model, validationMessages, hasUnsavedChanges) {
		this.context.setState({
			model: model,
			validationMessages: validationMessages,
			hasUnsavedChanges: hasUnsavedChanges == undefined ? this.context.state.hasUnsavedChanges : hasUnsavedChanges
		});
	}
}